// src/supabase/client.ts
import { createClient } from '@supabase/supabase-js';
import { Database } from '../../database.types';

// Replace with your actual Supabase project URL and anon/public key
const supabaseUrl = 'https://wwgwogsblbfjxeotrgod.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3Z3dvZ3NibGJmanhlb3RyZ29kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwMDk2OTgsImV4cCI6MjA1NDU4NTY5OH0.ypTWRlqKzQfTTIftt-Ee8EbbQEv1U77ICAuOQy7qXmk';


export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
  },
});
